var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-filterLabel",style:([
        {
            color:
                _vm.backgroundColor && !_vm.color
                    ? 'var(--color-primary)'
                    : _vm.color
                    ? _vm.color
                    : ''
        },
        { backgroundColor: _vm.backgroundColor }
    ])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.close)?_c('a-icon',{staticClass:"ml-2 mr-0",staticStyle:{"min-width":"16px"},attrs:{"width":"16px","height":"16px","icon":"Close"},nativeOn:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }